import type { HTMLAttributes } from 'react';

export function Skeleton({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={['animate-pulse bg-slate-200', className].join(' ')} {...props} />;
}
